import { Component, computed, signal } from '@angular/core'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'
import { DELIVERY_CHANNEL_TABS, DELIVERY_HELP_ASSETS, DELIVERY_HELP_BY_CHANNEL, DELIVERY_HELP_INTRO, DeliveryChannel } from '../../../helpers/delivery-status-help'
import { DeliveryChannelTabsComponent } from './components/delivery-channel-tabs/delivery-channel-tabs.component'
import { DeliveryFlowChainComponent } from './components/delivery-flow-chain/delivery-flow-chain.component'
import { DeliveryStatusTableComponent } from './components/delivery-status-table/delivery-status-table.component'

@Component({
  selector: 'app-delivery-status-modal',
  standalone: true,
  imports: [ModalComponent, DeliveryChannelTabsComponent, DeliveryFlowChainComponent, DeliveryStatusTableComponent],
  templateUrl: './delivery-status-modal.component.html',
  styleUrl: './delivery-status-modal.component.scss'
})
export class DeliveryStatusModalComponent {
  public readonly modalId = 'delivery-status-modal'
  public readonly tabs = DELIVERY_CHANNEL_TABS
  public readonly intro = DELIVERY_HELP_INTRO
  public readonly assets = DELIVERY_HELP_ASSETS

  public readonly activeChannel = signal<DeliveryChannel>('email')
  public readonly activeHelp = computed(() => DELIVERY_HELP_BY_CHANNEL[this.activeChannel()])

  /**
   * Emits the tab change event.
   * @param channel - The channel.
   */
  onTabChange(channel: DeliveryChannel): void {
    this.activeChannel.set(channel)
  }
}
